import React from "react";
import { translations } from "../../../config";
import { NavLink } from "react-router-dom";
import Access from "../../../components/Access";
import Icon from "../../../components/Icon";

const NavLinks = ( a_class ) =>
{
	let props = {};
	if ( a_class )
	{
		props["className"] = a_class;
	}
	
	return <ul key={"mainNav"} {...props}>
		<li><NavLink to="/">
			<Icon key={"home-icon"} iconName={"home"}/>
			<span key={"landingpage-text"}>Startseite</span>
		</NavLink></li>
		<Access permissions={[ "guest_user_permissions" ]}>
			<li><NavLink to="/richtlinienrecherche">
				<Icon key={"survey-overview-icon"} iconName={"surveyOverview"}/>
				<span key={"surveys-text"}>Richtlinienrecherche</span>
			</NavLink></li>
			<li><NavLink to="/preise">
				<Icon key={"money-icon"} iconName={"money"}/>
				<span key={"prices-text"}>Preise</span>
			</NavLink></li>
			<li><NavLink to={translations.de_DE.routes.questionnaires}>
				<Icon key={"apps-icon"} iconName={"apps"}/>
				<span key={"safety-apps-text"}>Imera</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_surveys" ]}>
			<li><NavLink to={translations.de_DE.routes.surveys}>
				<Icon key={"survey-overview-icon"} iconName={"surveyOverview"}/>
				<span key={"survey-overview-text"}>{translations.de_DE.words.surveys}übersicht</span></NavLink></li>
		</Access>
		<Access permissions={[ "get_questionnaires" ]}>
			<li><NavLink to={translations.de_DE.routes.questionnaires}>
				<Icon key={"questionnaire-configurator-icon"} iconName={"questionnaireConfigurator"}/>
				<span key={"questionnaire-configurator-text"}>{translations.de_DE.words.questionnaireCofigurator}</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_users" ]}>
			<li><NavLink to="/benutzerverwaltung">
				<Icon key={"user-icon"} iconName={"user"}/>
				<span key={"user-text"}>Benutzerverwaltung</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_organizations", "get_faktura_organizations" ]}>
			<li><NavLink to="/organisationsverwaltung">
				<Icon key={"organization-icon"} iconName={"organization"}/>
				<span key={"organization-text"}>Organisationsverwaltung</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_roles", "get_permissions" ]} exactly>
			<li><NavLink to="/berechtigungsverwaltung">
				<Icon key={"permission-icon"} iconName={"permission"}/>
				<span key={"permission-text"}>Berechtigungsverwaltung</span>
			</NavLink></li>
		</Access>
	</ul>;
	
}; // function NavLinks(...)

export default NavLinks;
